import * as actionTypes from '../actions/actionTypes'
const initialState = {
  showFeedback: false
}
const feedBackReducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case actionTypes.GET_FEEDBACK:
      return { ...newState, flag: true }

    case actionTypes.HIDE_FEEDBACK:
      return { ...newState, flag: false }

    default:
      return newState
  }
}
export default feedBackReducer
